export let GtkmAnimationState;
(function (GtkmAnimationState) {
  GtkmAnimationState["Stopped"] = "stopped";
  GtkmAnimationState["Started"] = "started";
  GtkmAnimationState["NotDisplayed"] = "notDisplayed";
})(GtkmAnimationState || (GtkmAnimationState = {}));